import axios from "./axios-handler.service";
import { Consultor } from "./consultores.service";
const BASE_URL = "/api/ProcessamentoFilaMensagem";

export enum StatusProcessamentoFilaMensagem {
  Criado = 1,
  Processando = 2,
  Finalizado = 3,
  Erro = 4
}

export enum StatusItemProcessamentoFilaMensagem {
  Pendente = 1,
  Processado = 2,
  Ignorado = 3,
  Erro = 4,
}

export interface ProcessamentoFilaMensagem {
  idProcessamentoFilaMensagem: string;
  idFilaMensagem: string;
  idConsultor: number;
  idUsuarioProcessamento?: number;
  status: StatusProcessamentoFilaMensagem;
  items: ItemProcessamentoFilaMensagem[];
  quantidadeTotal: number;
  quantidadePendente: number;
  quantidadeErro: number;
  quantidadeIgnorado: number;
  quantidadeProcessado: number;
}

export interface ItemProcessamentoFilaMensagem {
  idItemProcessamentoFilaMensagem: string;
  idProcessamentoFilaMensagem: string;
  ordem: number;
  tipo: string;
  jsonOriginal: string;
  jsonAlterado?: string;
  status: StatusItemProcessamentoFilaMensagem;
  dataProcessamento?: Date;
  dataErro?: Date;
  erro?: string;
}

export interface DadosGeraisProcessamento {
  processamento: ProcessamentoFilaMensagem;
  consultor: Consultor;
}

export class ProcessamentoFilaMensagensService {
  static async obterProcessamento(
    idProcessamentoFilaMensagem: string
  ): Promise<DadosGeraisProcessamento> {
    const response = await axios.get<DadosGeraisProcessamento>(
      `${BASE_URL}/ObterProcessamento`,
      {
        params: {
          idProcessamentoFilaMensagem
        },
      }
    );

    return response.data;
  }

  static async obterItem(
    idProcessamentoFilaMensagem: string,
    idItemProcessamentoFilaMensagem: string
  ): Promise<ItemProcessamentoFilaMensagem> {
    const response = await axios.get<ItemProcessamentoFilaMensagem>(
      `${BASE_URL}/ObterItem`,
      {
        params: {
          idProcessamentoFilaMensagem,
          idItemProcessamentoFilaMensagem
        },
      }
    );

    return response.data;
  }

  static async ignorarProcesso(
    idProcessamentoFilaMensagem: string,
    idItemProcessamentoFilaMensagem: string
  ): Promise<void> {
    const response = await axios.put(`${BASE_URL}/IgnorarProcesso`, null, {
      params: { idProcessamentoFilaMensagem, idItemProcessamentoFilaMensagem },
    });
    return response.data;
  }

  static async incluirProcesso(
    idProcessamentoFilaMensagem: string,
    idItemProcessamentoFilaMensagem: string
  ): Promise<void> {
    const response = await axios.put(`${BASE_URL}/IncluirProcesso`, null, {
      params: { idProcessamentoFilaMensagem, idItemProcessamentoFilaMensagem },
    });
    return response.data;
  }

  static async alterarJson(
    idProcessamentoFilaMensagem: string,
    idItemProcessamentoFilaMensagem: string,
    json: string
  ): Promise<void> {
    const response = await axios.put(`${BASE_URL}/AlterarJson`, { json }, {
      params: { idProcessamentoFilaMensagem, idItemProcessamentoFilaMensagem },
    });
    return response.data;
  }

  static async gerarProcessamento(
    idConsultor: number,
    idFilaMensagem: string
  ): Promise<string> {
    const response = await axios.post(`${BASE_URL}/GerarProcessamento`, null, {
      params: { idConsultor, idFilaMensagem },
    });
    return response.data;
  }

  static async iniciarProcessamento(
    idProcessamentoFilaMensagem: string
  ): Promise<void> {
    const response = await axios.get(`${BASE_URL}/ProcessarFilaMensagem`, {
      params: { idProcessamentoFilaMensagem },
    });
    return response.data;
  }
}
